import { useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { ConfirmContext, ContextType } from "./ConfirmContextProvider";

export const useConfirm = () => {
  const { t } = useTranslation();
  const [confirm, setConfirm] = useContext(ConfirmContext) as ContextType;
  const [needsCleanup, setNeedsCleanup] = useState(false);

  const isConfirmed = (prompt: string = t("general.are_you_sure"), body: string | null = null) => {
    const promise = new Promise((resolve, reject) => {
      setConfirm({ prompt, body, isOpen: true, proceed: resolve, cancel: reject });
      setNeedsCleanup(true);
    });

    const reset = () => {
      setConfirm({ prompt: "", body: null, proceed: null, cancel: null, isOpen: false });
      setNeedsCleanup(false);
    };

    return promise.then(
      () => {
        reset();
        return true;
      },
      () => {
        reset();
        return false;
      },
    );
  };

  // Call cancel in a cleanup func to avoid dangling confirm dialog
  useEffect(() => {
    return () => {
      if (confirm.cancel && needsCleanup) {
        confirm.cancel();
      }
    };
  }, [confirm, needsCleanup]);

  return {
    ...confirm,
    isConfirmed,
  };
};
